import React from 'react';
import { Redirect, type RouteContext } from '@atlassian/react-resource-router';

export const serviceDeskEmailNextGenRedirect = ({ match }: RouteContext): React.JSX.Element => {
	const { projectKey } = match.params;
	const url = `/jira/servicedesk/projects/${String(projectKey)}/settings/email`;

	return <Redirect to={url} />;
};
